import { notify } from 'notifications';
import { ProductionImageModalActions } from 'pages/production/controllers/production-image-modal.controller';
import { GetStateFunction } from 'redux/store';
import { ProductionWorkflowService } from 'services/production-workflow.service';
import { StateController } from 'state-controller';

export type ConfirmImageDeletionModalState = {
  isOpen: boolean;
  imageId: string;
  imageName: string;
  isLoading: boolean;
};

const defaultState: ConfirmImageDeletionModalState = {
  imageId: '',
  isOpen: false,
  imageName: '',
  isLoading: false,
};

const stateController = new StateController<ConfirmImageDeletionModalState>('CONFIRM_IMAGE_DELETION_MODAL', defaultState);

export class ConfirmImageDeletionModalActions {
  public static openModal(args: Pick<ConfirmImageDeletionModalState, 'imageId' | 'imageName'>) {
    return async (dispatch) => {
      dispatch(stateController.setState({ isOpen: true, ...args }));
    };
  }

  public static closeModal() {
    return async (dispatch) => {
      dispatch(stateController.setState({ isOpen: false }));
      setTimeout(() => dispatch(stateController.setState(defaultState)), 300);
    };
  }

  public static confirm(callback?: (productionId?: string) => void) {
    return async (dispatch, getState: GetStateFunction) => {
      try {
        const { imageId } = getState().production.confirmImageDeletionModal;
        const { productionInfo, images } = getState().production.productionImageModal;

        const target = images.find(({ id }) => id === imageId);

        dispatch(stateController.setState({ isLoading: true }));

        await ProductionWorkflowService.deleteProductionWorkflowImage(productionInfo.id, imageId);

        dispatch(ProductionImageModalActions.deleteImage(imageId));

        if (target && target.isMain) {
          callback?.(productionInfo.id);
        }

        dispatch(ConfirmImageDeletionModalActions.closeModal());

        notify.success('Successfully deleted');
      } catch (error) {
        notify.error(error.message);
      } finally {
        dispatch(stateController.setState({ isLoading: false }));
      }
    };
  }
}

export const reducer = stateController.getReducer();
